
import './styles/index.less'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { Provider } from 'react-redux'
// @ts-ignore
import VConsole from 'vconsole'
import { ConfigProvider, setDefaultConfig } from 'antd-mobile'
import router from '@/router'
import { store } from '@/stores/store'
import i18n, { getAntLangFile, getI18nLang } from '@/utils/i18n'
import { utils, lang, storageUtil, webviewFun } from '@/utils';
import { Suspense } from 'react';
import { Skeleton } from 'antd-mobile';
import UserProvider from '@/hooks/userContext';
import SafeArea from '@/components/SafeArea'

const NODE_ENV = import.meta.env.MODE

// 判断是否是生产环境的条件，打包是生产环境，或者app传的环境是生产环境
const isProduction = ['production'].includes(NODE_ENV)
if (!isProduction) {
  // 不是生产环境，并且不是本地开发，显示控制台
  const vConsole = new VConsole()
  console.log('vConsole', vConsole)
}
const { setLocalStorage } = storageUtil;
const { setUidToken, getUrlParameters } = utils;
const { getlang } = lang;
const { isInApp } = webviewFun;

// 缓存token、language
(async () => {
  const urlQuery: { [key: string]: string } = getUrlParameters(window.location.href) || {};
  await setUidToken(urlQuery);
  const currentLanguage = await getlang(urlQuery.language);
  setLocalStorage('language', currentLanguage);
  // @ts-ignore
  window.language = currentLanguage;

  const i18nLang = getI18nLang()
  i18n.changeLanguage(i18nLang)
  console.log('i18nLang', i18nLang)
  console.log('App 设置', currentLanguage);
  const locale = getAntLangFile()

  setDefaultConfig({
    locale,
  });


  if (isInApp()) {
    // 在 App 里面，客户端更新 token 后，会调用挂载在window上的 _handleMessageFromNative 方法，更新H5的 token
    window._handleMessageFromNative = () => {
      utils.setUidToken({});
    }
  }
})();

createRoot(document.getElementById('root')!).render(
  <Provider store={store}>
    <ConfigProvider>
      <Suspense fallback={
        <div style={{ padding: '10px' }}>
          <SafeArea position='top' />
          <Skeleton.Title animated />
          <Skeleton.Paragraph lineCount={5} animated />
        </div>
      }>
        <UserProvider>
          <RouterProvider router={router}></RouterProvider>
        </UserProvider>
      </Suspense>
    </ConfigProvider>
  </Provider>,
)